import { Modal, ModalProps } from '@design';
import clsx from 'clsx';
import React from 'react';

import styles from './ModalLarge.module.scss';

export const ModalLarge = ({ className, children, ...rest }: ModalProps) => (
  <Modal
    data-testid="modal-large"
    {...rest}
    className={clsx(styles.styledModal, className)}
  >
    <div data-testid="modal-large-content" className={styles.content}>
      {children}
    </div>
  </Modal>
);
